import useSWR from 'swr';
import axiosInstance from '@/lib/axios';
import type { Project, ProjectProposal } from '@/types';

const fetcher = (url: string) => axiosInstance.get(url).then((res) => res.data);

export function useProjects(communityId: string) {
  const { data, error, isLoading, mutate } = useSWR<Project[]>(
    communityId ? `/api/communities/${communityId}/projects` : null,
    fetcher
  );

  return {
    projects: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

export function useProject(communityId: string, projectId: string) {
  const { data, error, isLoading, mutate } = useSWR<Project>(
    communityId && projectId ? `/api/communities/${communityId}/projects/${projectId}` : null,
    fetcher
  );

  return {
    project: data,
    isLoading,
    isError: error,
    mutate,
  };
}

export function useAvailableProjects(communityId: string) {
  const { data, error, isLoading, mutate } = useSWR<Project[]>(
    communityId ? `/api/communities/${communityId}/projects/available` : null,
    fetcher
  );

  return {
    projects: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

export function useVendorProjects(communityId: string) {
  const { data, error, isLoading, mutate } = useSWR<Project[]>(
    communityId ? `/api/communities/${communityId}/projects/for-vendors` : null,
    fetcher
  );

  return {
    projects: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

export function useDistrictProjects(communityId: string) {
  const { data, error, isLoading, mutate } = useSWR<Project[]>(
    communityId ? `/api/communities/${communityId}/projects/district` : null,
    fetcher
  );

  return {
    projects: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

export function useProjectProposals(communityId: string, projectId: string) {
  const { data, error, isLoading, mutate } = useSWR<ProjectProposal[]>(
    communityId && projectId
      ? `/api/communities/${communityId}/projects/${projectId}/vendors`
      : null,
    fetcher
  );

  return {
    proposals: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}
